import { render, staticRenderFns } from "./UserPersonalCardCards.vue?vue&type=template&id=19c92520&"
import script from "./UserPersonalCardCards.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports